import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IoArrowBackSharp } from "react-icons/io5";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import "react-toastify/dist/ReactToastify.css";
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardHeader,
  CardText,
  CardTitle,
  Col,
  Form,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import swal from "sweetalert";
import {
  applyClassToCharacters,
  convertUTCToLocalTime,
  getStringFromJSX,
  isUrdu,
  LoadingSpinner,
} from "../../../constants/const";
import { GetLanguageString } from "../../helper/Components";
import { GetCustomStyles, GetSelectedLanguage } from "../../helper/Method";
import GenericSwitch from "../../shared/GenericSwitch";
import { addMember } from "../ApiMember";
import { ApiMemberTypeRequest } from "./ApiMemberTypeRequest";

const colors = {
  primary: "#1d9fad", // New primary color (teal-cyan)
  primaryLight: "#4dbbc8", // Lighter variant of new primary
  primaryDark: "#147d89", // Darker variant of new primary
  secondary: "#7DB9A2", // Dusty seafoam green
  accent: "#94C4CC", // Pale sky blue
  background: "#F8FBFB", // Very light blue-white
  text: "#2D3747", // Dark blue-gray
  textLight: "#6B7C8C", // Soft blue-gray
  border: "#D8E1E6", // Light blue-gray
  success: "#5AB885", // Muted green
  warning: "#E4B363", // Soft gold
  error: "#E67C73", // Dusty coral
  progressLine: "#D1DDE5", // Very light blue-gray
  stepInactive: "#E0E8EC", // Pale blue for inactive steps
};

const MemberTypeRequestMuatazir = ({ history, memberTypeData }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [values, setValues] = useState({});

  useEffect(() => {
    setLoading(true);
    setButtonDisable(true);
    ApiMemberTypeRequest()
      .DeclareMemberAsMutazirFormData({ memberId: memberTypeData.memberId })
      .then((res) => {
        setValues(res.data);
        setLoading(false);
        setButtonDisable(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setButtonDisable(false);
      });
    // eslint-disable-next-line
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setButtonDisable(true);
    memberTypeData.memberMutazirFormModel = values;
    addMember()
      .addMemberType(memberTypeData, false)
      .then((res) => {
        if (res.data === "CanNotChange") {
          swal({
            title: t("member__member_type_not_change_able"),
            icon: "warning",
            className: GetSelectedLanguage() === "en" ? "" : "ur",
            buttons: "OK",
          });
        } else if (res.data === "Request Already Generated") {
          swal({
            title: t(res.data),
            icon: "error",
            className: GetSelectedLanguage() === "en" ? "" : "ur",
            buttons: "OK",
          });
        } else {
          swal({
            title: t(res.data),
            icon: "success",
            className: GetSelectedLanguage() === "en" ? "" : "ur",
            buttons: "OK",
          });
          history.goBack();
        }
        setLoading(false);
        setButtonDisable(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setButtonDisable(false);
      });
  };
  return (
    <Card className="mb-4">
      <CardHeader className="bg-white d-flex justify-content-between align-items-center py-3">
        <h4 className="mb-0" style={{ fontSize: "1.25rem", fontWeight: 500 }}>
          {applyClassToCharacters(
            getStringFromJSX(
              <GetLanguageString
                props="member_member_type_request_title"
                value={memberTypeData.memberType.label}
              />
            ),
            "ur"
          )}
        </h4>
        <Button
          color="default"
          className="d-flex align-items-center"
          onClick={() => history.goBack()}
        >
          <IoArrowBackSharp className="me-2" color="#18A689" size={15} />
          {<GetLanguageString props="courses_participants_back" />}
        </Button>
      </CardHeader>
      <CardBody>
        {!loading ? (
          <Form onSubmit={handleSubmit}>
            {" "}
            <Row>
              <Col md="6">
                <Card
                  className="mb-3"
                  style={{
                    borderRadius: "10px",
                    boxShadow: "0 3px 10px rgba(0, 0, 0, 0.08)",
                    height: "100%",

                    border: "none",
                  }}
                >
                  <CardBody>
                    <CardTitle
                      tag="h5"
                      style={{
                        color: colors.primary,
                        fontWeight: "600",
                        fontSize: "16px",
                        marginBottom: "12px",
                      }}
                    >
                      <GetLanguageString
                        props={"member_member_type_request_muqami_tanzeem"}
                      />
                    </CardTitle>
                    <CardText
                      className={isUrdu(values.tanzeemName) ? "ur" : ""}
                      style={{
                        fontSize: "18px",
                        color: colors.text,
                        fontWeight: "600",
                        wordBreak: "break-word",
                      }}
                    >
                      {values.tanzeemName || "—"}
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
              <Col md="6">
                <Card
                  className="mb-3"
                  style={{
                    borderRadius: "10px",
                    boxShadow: "0 3px 10px rgba(0, 0, 0, 0.08)",
                    height: "100%",
                    border: "none",
                  }}
                >
                  <CardBody>
                    <CardTitle
                      tag="h5"
                      style={{
                        color: colors.primary,
                        fontWeight: "600",
                        fontSize: "16px",
                        marginBottom: "12px",
                      }}
                    >
                      <GetLanguageString props={"member_report_member_halqa"} />
                    </CardTitle>
                    <CardText
                      className={isUrdu(values.halqaName) ? "ur" : ""}
                      style={{
                        fontSize: "18px",
                        color: colors.text,
                        fontWeight: "600",
                        wordBreak: "break-word",
                      }}
                    >
                      {values.halqaName || "—"}
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <br></br>
            <Row>
              {[
                { key: "memberFullName", label: "common_name", isUrdu: true },
                {
                  key: "memberFatherName",
                  label: "member_father_name",
                  isUrdu: true,
                },
                { key: "memberAge", label: "member_age", isUrdu: false },
                {
                  key: "memberRegistrationNumber",
                  label: "member_report_member_registrationNumber",
                  isUrdu: true,
                },
              ].map((field) => (
                <Col md="3">
                  <Card
                    className="mb-3"
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0 3px 10px rgba(0, 0, 0, 0.08)",
                      height: "100%",
                      border: "none",
                    }}
                  >
                    <CardBody>
                      <CardTitle
                        tag="h5"
                        style={{
                          color: colors.primary,
                          fontWeight: "600",
                          fontSize: "16px",
                          marginBottom: "12px",
                        }}
                      >
                        <GetLanguageString props={field.label} />
                      </CardTitle>
                      <CardText
                        className={
                          field.isUrdu && isUrdu(values[field.key]) ? "ur" : ""
                        }
                        style={{
                          fontSize: "16px",
                          color: colors.text,
                          wordBreak: "break-word",
                        }}
                      >
                        {values[field.key] || "—"}
                      </CardText>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
            <br></br>
            <Row>
              {[
                {
                  key: "memberPledgeDate",
                  label: "member_member_detail_pledges_date",
                  isUrdu: false,
                },
                {
                  key: "multazimCourseStartDate",
                  label: "member_member_type_request_multazim_course_date",
                  isUrdu: false,
                },
                {
                  key: "multazimCompletedCourseLocation",
                  label: "member_member_type_request_multazim_course_location",
                  isUrdu: true,
                },
                {
                  key: "multazimNisaabStatus",
                  label: "book_update_book3",
                  isUrdu: false,
                },
              ].map((field) => (
                <Col md="3">
                  <Card
                    className="mb-3"
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0 3px 10px rgba(0, 0, 0, 0.08)",
                      height: "100%",
                      border: "none",
                    }}
                  >
                    <CardBody>
                      <CardTitle
                        tag="h5"
                        style={{
                          color: colors.primary,
                          fontWeight: "600",
                          fontSize: "16px",
                          marginBottom: "12px",
                        }}
                      >
                        <GetLanguageString props={field.label} />
                      </CardTitle>
                      <CardText
                        className={
                          field.isUrdu && isUrdu(values[field.key]) ? "ur" : ""
                        }
                        style={{
                          fontSize: "16px",
                          wordBreak: "break-word",
                          color: field.key.includes("Nisaab")
                            ? values[field.key]
                              ? "green"
                              : "red"
                            : colors.text,
                        }}
                      >
                        {field.key.includes("date")
                          ? values[field.key]
                            ? moment(
                                convertUTCToLocalTime(values[field.key])
                              ).format("DD/MM/yyyy")
                            : ""
                          : field.key.includes("Nisaab")
                          ? values[field.key]
                            ? t("courses_status_completed")
                            : t("courses_status_incompleted")
                          : values[field.key] || "—"}
                      </CardText>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
            <br></br>{" "}
            <Row>
              {[
                {
                  key: "mubtadiCourseStartDate",
                  label: "member_member_type_request_mubtadi_course_date",
                  isUrdu: false,
                },
                {
                  key: "mubtadiCompletedCourseLocation",
                  label: "member_member_type_request_mubtadi_course_location",
                  isUrdu: true,
                },
                {
                  key: "mubtadiNisaabStatus",
                  label: "book_update_book2",
                  isUrdu: false,
                },
              ].map((field) => (
                <Col md="3">
                  <Card
                    className="mb-3"
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0 3px 10px rgba(0, 0, 0, 0.08)",
                      height: "100%",
                      border: "none",
                    }}
                  >
                    <CardBody>
                      <CardTitle
                        tag="h5"
                        style={{
                          color: colors.primary,
                          fontWeight: "600",
                          fontSize: "16px",
                          marginBottom: "12px",
                        }}
                      >
                        <GetLanguageString props={field.label} />
                      </CardTitle>
                      <CardText
                        className={
                          field.isUrdu && isUrdu(values[field.key]) ? "ur" : ""
                        }
                        style={{
                          fontSize: "16px",
                          wordBreak: "break-word",
                          color: field.key.includes("Nisaab")
                            ? values[field.key]
                              ? "green"
                              : "red"
                            : colors.text,
                        }}
                      >
                        {field.key.includes("date") ? (
                          values[field.key] ? (
                            moment(
                              convertUTCToLocalTime(values[field.key])
                            ).format("DD/MM/yyyy")
                          ) : (
                            ""
                          )
                        ) : field.key.includes("Nisaab") ? (
                          values[field.key] ? (
                            <GetLanguageString
                              props={"courses_status_completed"}
                            />
                          ) : (
                            <GetLanguageString
                              props={"courses_status_incompleted"}
                            />
                          )
                        ) : (
                          values[field.key] || "—"
                        )}
                      </CardText>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
            <br></br>
            <hr></hr>
            <br></br>
            <Row>
              {" "}
              <Col md="6">
                <FormGroup>
                  <Row>
                    <Col md="10">
                      <Label
                        className="col-form-label ur"
                        style={{ fontSize: 15 }}
                      >
                        فرائض و واجبات اور شعائر دینی کے ضمن میں نمایا پسپائی؟
                      </Label>
                    </Col>
                    <Col md="2" style={{ marginTop: 5 }}>
                      <GenericSwitch
                        label="declineInReligiousObligations"
                        value={values.declineInReligiousObligations}
                        setValues={setValues}
                      />
                    </Col>
                  </Row>
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Row>
                    <Col md="10">
                      <Label
                        className="col-form-label ur"
                        style={{ fontSize: 15 }}
                      >
                        طے شدہ اجتماعات سے بلا حقیقی عذر مسلسل غیر حاضری یا
                        (منفرد ہونے کی صورت میں تین ماہ تک ماہانہ رپورٹ ارسال نا
                        کرنا )؟
                      </Label>
                    </Col>
                    <Col md="2" style={{ marginTop: 5 }}>
                      <GenericSwitch
                        label="repeatedAbsenceWithoutValidReason"
                        value={values.repeatedAbsenceWithoutValidReason}
                        setValues={setValues}
                      />
                    </Col>
                  </Row>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              {" "}
              <Col md="6">
                <FormGroup>
                  <Row>
                    <Col md="10">
                      <Label
                        className="col-form-label ur"
                        style={{ fontSize: 15 }}
                      >
                        ذاتی انفرادی دعوتی کام سے مسلسل پہلو تہی؟
                      </Label>
                    </Col>
                    <Col md="2" style={{ marginTop: 5 }}>
                      <GenericSwitch
                        label="lackOfPersonalDawahEffort"
                        value={values.lackOfPersonalDawahEffort}
                        setValues={setValues}
                      />
                    </Col>
                  </Row>
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Row>
                    <Col md="10">
                      <Label
                        className="col-form-label ur"
                        style={{ fontSize: 15 }}
                      >
                        ماہانہ انفاق کے معاملے میں مسلسل کوتاہی؟
                      </Label>
                    </Col>
                    <Col md="2" style={{ marginTop: 5 }}>
                      <GenericSwitch
                        label="monthlyInfaqNegligence"
                        value={values.monthlyInfaqNegligence}
                        setValues={setValues}
                      />
                    </Col>
                  </Row>
                </FormGroup>
              </Col>
            </Row>
            <br></br>
            <Row>
              <Col md="8"></Col>
              <Col md="4">
                <ButtonGroup className={GetCustomStyles().btn_group_style}>
                  <Button color="white" onClick={() => history.goBack()}>
                    {<GetLanguageString props="common_cancel" />}
                  </Button>
                  &nbsp;&nbsp;
                  <Button
                    color="primary"
                    disabled={buttonDisable}
                    className="m-l-sm"
                    type="submit"
                  >
                    {<GetLanguageString props="common_save_changes" />}
                  </Button>
                </ButtonGroup>
              </Col>
            </Row>
          </Form>
        ) : (
          LoadingSpinner()
        )}
      </CardBody>
    </Card>
  );
};

export default withRouter(MemberTypeRequestMuatazir);
